//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import React from 'react';

import {
  ContactSupport,
  SupportRequestContext,
} from '@campaigns/components/shared/ContactSupport';
import { SAMPLING_CAMPAIGNS_TRACKING_ID } from '@campaigns/constants/sampling/SamplingCampaignsTrackingId';
import { Alert } from '@components/atoms/alert/Alert';
import { RequestError } from '@utils/sessionFetch';

interface SamplingCampaignQueryErrorAlertProps {
  error?: RequestError;
  message?: string;
  requestContext?: SupportRequestContext;
}

export const SamplingCampaignQueryErrorAlert = ({
  error,
  message,
  requestContext,
}: SamplingCampaignQueryErrorAlertProps) => {
  if (error?.statusCode === 403) {
    return (
      <Alert type='error'>
        You don't have access to this feature. Contact your Account Manager for
        more information.
      </Alert>
    );
  }

  return (
    <Alert type='error'>
      {message ?? 'An unexpected error occurred. Please try again later.'}{' '}
      <ContactSupport
        leadingCopy='If the problem continues, email'
        requestContext={requestContext}
        trackingId={
          SAMPLING_CAMPAIGNS_TRACKING_ID.QUERY_ERROR_ALERT_CONTACT_SUPPORT_LINK
        }
      />
      .
    </Alert>
  );
};
